import type { ModelSpec } from '../shapes';

export const ANIMALS: ModelSpec[] = [
  {
    id: 'cat3d',
    label: 'Cat',
    group: 'Animals',
    parts: { ear: 'ear', eye: 'eye', nose: 'nose', whiskers: 'whiskers', paw: 'paw', tail: 'tail', collar: 'collar', back: 'back' },
    shapes: [
      { part: 'body', k: 'sphere', s: [0.8], p: [0, 0.95, 0], sc: [0.85, 1, 0.75], c: '#f0a54a', f: 'soft' },
      { part: 'back', k: 'sphere', s: [0.5], p: [0, 1.15, -0.38], sc: [1.2, 1, 0.6], c: '#c97b2c', f: 'soft' },
      { part: 'head', k: 'sphere', s: [0.5], p: [0, 1.95, 0.15], c: '#f0a54a', f: 'soft' },
      { part: 'ear', k: 'cone', s: [0.17, 0.35], p: [0.3, 2.42, 0.1], r: [0, 0, -20], c: '#f0a54a', f: 'soft', mx: true },
      { part: 'eye', k: 'sphere', s: [0.07], p: [0.18, 2.05, 0.6], c: '#2f7d4f', f: 'shiny', mx: true },
      { part: 'nose', k: 'sphere', s: [0.055], p: [0, 1.9, 0.65], c: '#e86a7a', f: 'shiny' },
      { part: 'whiskers', k: 'tube', s: [0.02], p: [0.1, 1.85, 0.6], to: [0.5, 1.9, 0.62], c: '#ffffff', mx: true },
      { part: 'whiskers', k: 'tube', s: [0.02], p: [0.1, 1.82, 0.6], to: [0.5, 1.76, 0.62], c: '#ffffff', mx: true },
      { part: 'collar', k: 'torus', s: [0.36, 0.05], p: [0, 1.55, 0.12], r: [90, 0, 0], c: '#d8473b' },
      { part: 'collar', k: 'sphere', s: [0.07], p: [0, 1.47, 0.48], c: '#e1b542', f: 'metal' },
      { k: 'capsule', s: [0.13, 0.45], p: [0.25, 0.4, 0.32], c: '#f0a54a', f: 'soft', mx: true },
      { part: 'paw', k: 'sphere', s: [0.16], p: [0.25, 0.1, 0.42], sc: [1, 0.65, 1.3], c: '#ffffff', f: 'soft', mx: true },
      { part: 'tail', k: 'tube', s: [0.08], p: [0, 0.45, -0.5], to: [0.35, 0.5, -0.85], c: '#c97b2c', f: 'soft' },
      { part: 'tail', k: 'sphere', s: [0.08], p: [0.35, 0.5, -0.85], c: '#c97b2c', f: 'soft' },
      { part: 'tail', k: 'tube', s: [0.08], p: [0.35, 0.5, -0.85], to: [0.45, 1.25, -0.9], c: '#c97b2c', f: 'soft' },
      { part: 'tail', k: 'sphere', s: [0.08], p: [0.45, 1.25, -0.9], c: '#c97b2c', f: 'soft' },
    ],
  },
];
